import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { IconType } from './IconTypes.enum';

export enum IconSize {
  Small = '16px',
  Medium = '24px'
}

export enum IconVariant {
  Solid = 'solid',
  Outline = 'outline'
}

export interface IconProps {
  type: IconType;
  size?: IconSize;
  variant?: IconVariant;
  [key: string]: any;
  style?: React.CSSProperties;
}

export type IconSizeMapping = {
  [IconSize.Small]: React.FC<React.SVGProps<SVGSVGElement>>;
  [IconSize.Medium]: React.FC<React.SVGProps<SVGSVGElement>>;
};

export type IconVariantMapping = {
  [IconVariant.Outline]?: IconSizeMapping;
  [IconVariant.Solid]?: IconSizeMapping;
};

export type SVGComponent = React.FC<
  React.PropsWithChildren<
    CustomIconComponentProps | React.SVGProps<SVGSVGElement>
  >
>;
